import React from "react";
import style from "./breadcrumb.module.css";
import { Link } from "gatsby";

class Breadcrumb extends React.Component {
  render() {
    const OptionsArray = this.props.data;
    return (
      <div className={style.container}>
        {OptionsArray &&
          OptionsArray.map(option => (
            <div className={style.option}>
              {option.backIcon ? (
                <img className={style.arrowIcon} src={option.backIcon} alt="" />
              ) : null}
              {option.icon ? (
                <img className={style.arrowIcon} src={option.icon} alt="" />
              ) : null}
              {option.isUrl === false ? (
                <p className={style.optionText}>{option.label}</p>
              ) : (
                <Link to={`${option.url}/`}>
                  <p className={style.optionText} style={{fontWeight:"bold"}}>
                    {option.label}
                  </p>
                </Link>
              )}
            </div>
          ))}
      </div>
    );
  }
}

export default Breadcrumb;
